import { useState, useEffect } from "react";
import { Button, Form, Input, notification, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { get, post, put } from "../../../services";

const EventForm = () => {
  const { id } = useParams(); // This will get the 'id' from the URL
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [information, setInformation] = useState({});
  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  // useEffect to get content
  useEffect(() => {
    get(`/user/bankdetails/${id}`)
      .then((response) => {
        console.log("information", response);
        setInformation(response?.data);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    // setLoader(true);
    let payload = {
      bankName: values?.bankName,
      accountNumber: values?.accountNumber,
      ifscCode: values?.ifscCode,
      branchName: values?.branchName,
    };
    put(`/user/bankdetails/${information?.employeeId?._id}`, payload)
      .then(() => {
        setLoader(false);
        navigate("/bank");
        openNotification("Success", "Bank Details Updated Successfully");
      })
      .catch((error) => {
        setLoader(false);
        openNotification("Error", error?.response?.data?.message);
      });
  };

  return (
    <>
      <div className="header">
        <h3>Add Task</h3>
      </div>{" "}
      {!loader ? (
        <div className="form_container">
          <Form
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              bankName: information?.bankName,
              accountNumber: information?.accountNumber,
              branchName: information?.branchName,
              ifscCode: information?.ifscCode,
            }}
          >
            <Form.Item
              name="bankName"
              label="Bank Name"
              rules={[
                { required: true, message: "Please enter your Bank Name" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="accountNumber"
              label="Account Number"
              rules={[
                { required: true, message: "Please enter your Account Number" },
              ]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item
              name="ifscCode"
              label="Code"
              rules={[{ required: true, message: "Please enter your Code" }]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item
              name="branchName"
              label="Branch Name"
              rules={[
                { required: true, message: "Please enter your Branch Name" },
              ]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item>
              <div className="form_submit">
                <Button
                  className="back_button"
                  onClick={() => navigate("/bank")}
                >
                  Back
                </Button>
                <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <div className="spin_information">
          <Spin />
        </div>
      )}
    </>
  );
};
export default EventForm;
